import { render, staticRenderFns } from "./AlphaMainCustomerAgreement.vue?vue&type=template&id=0650d464&scoped=true"
var script = {}
import style0 from "./AlphaMainCustomerAgreement.vue?vue&type=style&index=0&id=0650d464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650d464",
  null
  
)

export default component.exports